import { BroadcastForm } from '../broadcast-form';
import { BroadcastProgress } from '../BroadcastProgress';
import { BroadcastPreview } from '../BroadcastPreview';
import { FlexCell, FlexRow } from '@epam/promo';
import { isBroadcastReadonly } from '../../../hooks/helpers';
import { useMemo } from 'react';
import { useBroadcastStore } from '../../../store/broadcast';

export const BroadcastView = () => {
  const { draft } = useBroadcastStore((state) => state);
  const isReadonly = useMemo(
    () => isBroadcastReadonly(draft.status),
    [draft.status],
  );

  return (
    <FlexRow columnGap="12">
      <FlexCell alignSelf="start" grow={2.5}>
        <BroadcastForm />
      </FlexCell>
      {isReadonly ? (
        <FlexCell alignSelf="start" grow={1}>
          <BroadcastProgress />
        </FlexCell>
      ) : (
        <FlexCell alignSelf="start" grow={1}>
          <BroadcastPreview></BroadcastPreview>
        </FlexCell>
      )}
    </FlexRow>
  );
};
